import { ActionColumn, RowForm } from "@airborne/react-admin";
import * as React from "react";
import { BooleanInput, required, TextInput } from "react-admin";

const CustomerUserCreateForm = props => {
  return (
    <RowForm {...props} mutationMode={"pessimistic"}>
      <TextInput source="registerId" label="Register Id" variant="outlined" validate={required()} />
      <TextInput source="ownerCode" label="Owner Code" variant="outlined" validate={required()} />
      <BooleanInput source="isEditable" label="Is Editable" variant="outlined" initialValue={true} />
      <ActionColumn />
    </RowForm>
  );
};

export default CustomerUserCreateForm;
